<svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1147 4.00358C13.0087 3.70209 12.7213 3.5 12.3984 3.5C12.0756 3.5 11.7882 3.70209 11.6822 4.00358L9.818 9.30644L4.1413 9.42083C3.81855 9.42733 3.53535 9.63517 3.4356 9.93873C3.33584 10.2423 3.4414 10.575 3.69864 10.7679L8.2232 14.1596L6.57902 19.5332C6.48554 19.8387 6.59794 20.1692 6.8591 20.3568C7.12026 20.5444 7.47292 20.548 7.73789 20.3657L12.3984 17.159L17.059 20.3657C17.324 20.548 17.6766 20.5444 17.9378 20.3568C18.1989 20.1692 18.3113 19.8387 18.2179 19.5332L16.5737 14.1596L21.0982 10.7679C21.3555 10.575 21.461 10.2423 21.3613 9.93873C21.2615 9.63517 20.9783 9.42733 20.6556 9.42083L14.9789 9.30644L13.1147 4.00358Z"
        fill="#D4D4D4"
    />
</svg>
